import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.182 15.187a4.5 4.5 0 0 1-6.364 0M21 12.005a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9.75 9.755c0 .414-.168.75-.375.75S9 10.169 9 9.755c0-.415.168-.75.375-.75s.375.335.375.75m-.375 0h.008v.015h-.008zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75c0-.415.168-.75.375-.75s.375.335.375.75m-.375 0h.008v.015h-.008z"
    }, null, -1)
  ])))
}
export default { render: render }